import React, { createContext, useContext } from "react";

import { ExportWizardModalType, INITIAL_DATA, useExportWizardModal } from "./use_export_wizard_modal";

const INITIAL_EXPORT_WIZARD_MODAL = {
  open: () => {},
  close: () => {},
  updateData: () => {},
  state: {
    isOpen: false,
    data: INITIAL_DATA
  }
};

const ExportWizardModalContext = createContext<ExportWizardModalType>(INITIAL_EXPORT_WIZARD_MODAL);

export const ExportWizardModalProvider = ({ children }: React.PropsWithChildren): JSX.Element => {
  const modal = useExportWizardModal();

  return (
    <ExportWizardModalContext.Provider value={{ ...modal }}>{children}</ExportWizardModalContext.Provider>
  );
};

export const useExportWizardModalContext = () => useContext<ExportWizardModalType>(ExportWizardModalContext);
